import cx from 'clsx';
import React from 'react';

import { ReactComponent as ArrowNextIcon } from '@assets/svg/arrow-next.svg';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const StepsInfo = ({ userFormSteps, userId, step }) => {
  const { t } = useTranslation();

  return (
    <div className={style.modalStepsLine}>
      {userFormSteps.map((formStep, i) => (
        <span
          key={formStep.stepName}
          className={cx(style.stepNameItem, {
            [style.currentStep]: i === step,
            [style.activeStep]: userId,
          })}
        >
          {t(formStep.stepName)}
          {userFormSteps.length !== i + 1 && <ArrowNextIcon className={style.arrowNext} />}
        </span>
      ))}
    </div>
  );
};

export default StepsInfo;
